import React from 'react';
import LessonHero from './LessonHero';
import ActivityCardView from './cards/ActivityCard';
import { linkCardModel } from './cards/cardModel';
import './activity-layout.css';

/**
 * A level section grouping related cards:
 *   level   - e.g. "B2"
 *   label   - e.g. "B2 – Upper-Intermediate"
 *   tagline - optional span text
 *   cards   - array of ActivityCard props
 *
 * The cards are the shared ActivityCard, so a vocabulary page and a lesson plan
 * page are built from the same component.
 */
export const ActivityLevel = ({ level, label, tagline, cards = [] }) => (
  <section className={`level level-${String(level).toLowerCase()}`}>
    <h2>
      {label}
      {tagline && <span>{tagline}</span>}
    </h2>
    <div className="activity-card-grid">
      {cards.map((card, i) => (
        <ActivityCardView key={i} {...linkCardModel(card)} cta="Open" />
      ))}
    </div>
  </section>
);

/**
 * Shared activity listing frame.
 *
 * children       -> SEO + Breadcrumb (kept inside the page container)
 * seoContent     -> array of paragraph strings rendered between the hero
 *                   and the level sections (useful indexable copy)
 * levels         -> array of { level, label, tagline, cards }
 *
 * The hero is the same LessonHero band the lesson pages open with, so a listing
 * and a lesson in it look like one site. `eyebrow` is the short category word
 * shown above the title (e.g. "Grammar").
 */
export const ActivityLayout = ({
  title,
  image,
  intro,
  eyebrow,
  levels = [],
  seoContent = [],
  children,
}) => (
  <div className="activity-page">
    <LessonHero title={title} image={image} description={intro} eyebrow={eyebrow} />

    <div className="activity-page__inner">
      {seoContent.length > 0 && (
        <div className="activity-content">
          {seoContent.map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      )}

      {children}

      {levels.map((lvl, i) => (
        <ActivityLevel key={i} {...lvl} />
      ))}
    </div>
  </div>
);

export default ActivityLayout;